import { createMuiTheme } from '@material-ui/core/styles';

// TODO https://applearn.atlassian.net/browse/AD-2950
export const MiUiTheme: any = createMuiTheme({
    typography: {
        useNextVariants: true,
        fontFamily: ['Inter', 'sans-serif'].join(','),
        body1: {
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: 14,
        },
        subtitle1: {
            fontFamily: ['Inter', 'sans-serif'].join(','),
            lineHeight: 1,
            fontSize: 14,
            fontWeight: 700,
        },
        h6: {
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: 16,
            fontWeight: 700
        }
    },
    shape: {
        borderRadius: 0,
    },
    palette: {
        primary: {
            main: '#0C6FC6',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#91B0CC',
            contrastText: '#ffffff',
        },
        tertiary: {
            main: '#191E24',
            contrastText: '#ffffff',
            backgroundColor: '#191E24',
            color: '#ffffff',
        },
        fourth: {
            backgroundColor: '#6A5667',
        },
        fifth: {
            backgroundColor: '#272D36',
        },
        sixth: {
            color: '#16243d',
        },
        hoverBackground: {
            backgroundColor: '#05A4D526',
        },
        background: {
            default: '#FAFAFA',
        },
        textPrimary: {
            color: '#ffffff',
        },
    },
    zIndex: {
        mobileStepper: 1000000,
        appBar: 1000100,
        drawer: 1000200,
        modal: 1058000,
        snackbar: 1000400,
        tooltip: 1000500,
    },
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: 'none',
            },
        },
        MuiCard: {
            root: {
                boxShadow: 'none',
            },
        },
        MuiExpansionPanel: {
            root: {
                boxShadow: 'none',
                '&:before': {
                    backgroundColor: 'inherit',
                },
            },
        },
        MuiLinearProgress: {
            root: {
                height: 10,
                margin: '10px 0',
            },
            colorPrimary: '#f4f4f4',
        },
        MuiTouchRipple: {
            root: {
                color: '#05A4D5',
            },
        },
        MuiButton: {
            root: {
                fontSize: 11,
                fontWeight: 600,
                lineHeight: 'normal',
            },
            outlined: {
                borderRadius: 4,
            },
            contained: {
                borderRadius: 4,
            },
            sizeSmall: {
                marginRight: 16,
            },
        },
        MuiFormLabel: {
            root: {
                color: '#282828',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'inherit',
                '&:hover': {
                    backgroundColor: 'inherit',
                },
            },
            '&$focused': {
                backgroundColor: 'inherit',
            },
            input: {
                paddingTop: 15,
                paddingRight: 32,
                paddingBottom: 15,
                paddingLeft: 12,
            },
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottom: `2px solid #05A4D5`,
                },
                '&:hover:not([disabled]):not([focused]):not([error]):before': {
                    borderBottom: `2px solid #05A4D5 !important`,
                },
            },
        },
        MuiInputBase: {
            root: {
                fontSize: 14,
            },
            input: {
                textOverflow: 'ellipsis',
            },
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'inherit',
                },
            },
        },
        MuiSnackbarContent: {
            root: {
                marginTop: 5,
                marginRight: 20,
            },
        },
        MuiInputLabel: {
            formControl: {
                transform: 'none',
            },
        },
        MuiFormControl: {
            root: {},
        },
        MuiInputAdornment: {
            positionEnd: {
                marginLeft: -33,
            },
        },
        MuiTabs: {
            flexContainer: {
                overflow: 'auto',
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '0.9375rem',
            },
        },
    },
} as any);
